import { API_ENDPOINTS } from '../endpoints';
import { getAuthHeaders, handleResponse } from '../client';
import type { CurrentUserVO, PermissionConfigVO, RoleOptionVO, UserOptionVO } from '../types';

export const permissionConfigApi = {
  getMyPermissionCodes: async (): Promise<string[]> => {
    const response = await fetch(API_ENDPOINTS.PERMISSION_CONFIG.MY_PERMISSION_CODES, {
      headers: getAuthHeaders(),
    });
    return handleResponse<string[]>(response);
  },

  getMe: async (): Promise<CurrentUserVO> => {
    const response = await fetch(API_ENDPOINTS.PERMISSION_CONFIG.ME, {
      headers: getAuthHeaders(),
    });
    return handleResponse<CurrentUserVO>(response);
  },

  getRoles: async (): Promise<RoleOptionVO[]> => {
    const response = await fetch(API_ENDPOINTS.PERMISSION_CONFIG.ROLES, {
      headers: getAuthHeaders(),
    });
    return handleResponse<RoleOptionVO[]>(response);
  },

  getUsers: async (): Promise<UserOptionVO[]> => {
    const response = await fetch(API_ENDPOINTS.PERMISSION_CONFIG.USERS, {
      headers: getAuthHeaders(),
    });
    return handleResponse<UserOptionVO[]>(response);
  },

  /** 具备可编辑或系统管理权限的用户（Owner 候选） */
  getMutableUsers: async (): Promise<UserOptionVO[]> => {
    const response = await fetch(API_ENDPOINTS.PERMISSION_CONFIG.MUTABLE_USERS, {
      headers: getAuthHeaders(),
    });
    return handleResponse<UserOptionVO[]>(response);
  },

  getConfig: async (): Promise<PermissionConfigVO> => {
    const response = await fetch(API_ENDPOINTS.PERMISSION_CONFIG.BASE, {
      headers: getAuthHeaders(),
    });
    return handleResponse<PermissionConfigVO>(response);
  },

  upsertRolePermission: async (data: { role_code: string; permission: string }): Promise<boolean> => {
    const response = await fetch(API_ENDPOINTS.PERMISSION_CONFIG.UPSERT_ROLE, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify(data),
    });
    await handleResponse<unknown>(response);
    return true;
  },

  upsertUserPermission: async (data: { user_id: number; permission: string }): Promise<boolean> => {
    const response = await fetch(API_ENDPOINTS.PERMISSION_CONFIG.UPSERT_USER, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify(data),
    });
    await handleResponse<unknown>(response);
    return true;
  },

  deleteRolePermission: async (roleCode: string): Promise<boolean> => {
    const response = await fetch(API_ENDPOINTS.PERMISSION_CONFIG.DELETE_ROLE(roleCode), {
      method: 'DELETE',
      headers: getAuthHeaders(),
    });
    await handleResponse<unknown>(response);
    return true;
  },

  deleteUserPermission: async (userId: number): Promise<boolean> => {
    const response = await fetch(API_ENDPOINTS.PERMISSION_CONFIG.DELETE_USER(userId), {
      method: 'DELETE',
      headers: getAuthHeaders(),
    });
    await handleResponse<unknown>(response);
    return true;
  },
};

// ===== REQ-013: 关键节点监控 API =====
